import { BoxMultipleRegular } from '@fluentui/react-icons';
import { PageHeader, CellMono, CellDate } from '../common';
import type { DataTableColumn } from '../common';
import { AsyncList } from '../common/AsyncList';
import { useProductVersions, type ProductVersions } from './useProductVersions';

const columns: DataTableColumn<ProductVersions>[] = [
  { key: 'product', header: 'Product', render: (p) => p.displayName },
  { key: 'latest', header: 'Latest version', render: (p) => <CellMono>{p.latestVersion}</CellMono> },
  { key: 'count', header: 'Versions uploaded', render: (p) => p.versionCount },
  { key: 'uploaded', header: 'Last upload', render: (p) => <CellDate date={p.lastUploadedAt} /> },
];

export function ProductsPage() {
  const products = useProductVersions();

  return (
    <div>
      <PageHeader
        title="Products"
        description="The FirstIQ products this Deployment Manager can install, and their package versions."
      />
      <AsyncList
        state={products}
        columns={columns}
        keyExtractor={(p) => p.productId}
        loadingLabel="Loading products..."
        empty={{
          icon: <BoxMultipleRegular />,
          title: 'No products listed yet',
          description:
            'Wave 1 products and the package versions uploaded for deployment will appear here once the Deployment Manager reads them from package storage.',
        }}
      />
    </div>
  );
}
